import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import TrfToStoreProcessActions from '../../Stores/TrfToStoreProcess/Actions';

import OutbOrd06Table from '../OutbOrd06/OutbOrd06Table';
import StkIssSync02Table from '../StkIssSync02/StkIssSync02Table';
import StkRcpt02Table from '../StkRcpt02/StkRcpt02Table';
import StkRcptSync02Table from '../StkRcptSync02/StkRcptSync02Table';
import StkIssFServ01Table from '../StkIssFServ01/StkIssFServ01Table';

const { TabPane } = Tabs;

class TrfToStoreProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curDivisionId, fetchTrfToStoreProcess } = this.props;
    if (curDivisionId > 0) {
      fetchTrfToStoreProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curDivisionId, fetchTrfToStoreProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curDivisionId')) {
      if (curDivisionId > 0) {
        fetchTrfToStoreProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/trfToStoreProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'OUTB_ORD_06' && <OutbOrd06Table match={match} />}
        {match.params.proc_type === 'STK_ISS_SYNC_02' && <StkIssSync02Table match={match} />}
        {match.params.proc_type === 'STK_RCPT_02' && <StkRcpt02Table match={match} />}
        {match.params.proc_type === 'STK_RCPT_SYNC_02' && <StkRcptSync02Table match={match} />}
        {match.params.proc_type === 'STK_ISS_F_SERV_01' && <StkIssFServ01Table match={match} />}
      </Card>
    );
  }
}

TrfToStoreProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curDivisionId: PropTypes.number,
  fetchTrfToStoreProcess: PropTypes.func
};

TrfToStoreProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curDivisionId: 0,
  fetchTrfToStoreProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.trfToStoreProcess.process,
  processIsLoading: state.trfToStoreProcess.processIsLoading,

  curDivisionId: state.app.curDivisionId
});

const mapDispatchToProps = dispatch => ({
  fetchTrfToStoreProcess: () =>
    dispatch(TrfToStoreProcessActions.trfToStoreProcessFetchTrfToStoreProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TrfToStoreProcessScreen));
